import formInitialValues from '../formik/editar/formInitialValues';

export const toCreateEmployeePayload = (employee: any) => {
  return {
    employee_avatar: employee.employee_avatar, // 'default.png',
    typeDocument: employee.document_type?.value,
    document_number: employee.document_number?.toString(),
    expedition_place: employee.expedition_place,
    name: employee.name,
    last_name: employee.last_name,
    birthdate: employee.date_of_birth,
    gender: employee.gender?.value,
    civil_status: employee.civil_status?.value,
    landline: employee.landline,
    cell_phone: employee.cell_phone?.toString(),
    corporate_cell_phone: employee.corporate_cell_phone?.toString(),
    whatsapp: Number(employee.whatsapp),
    rh: employee.rh?.value,
    dominance: employee.dominance?.value,
    allergies: employee.allergies,
    cedula_name_saved_name: employee.cedula_name_saved_name,
    housing_type: employee.housing_type?.value,
    address: employee.address,
    neighborhood: employee.neighborhood,
    stratum: employee.stratum?.toString(),
    cost_center: employee.cost_center?.value,
    compani: employee.compani?.value,
    work_headquarters: employee.work_headquarters?.value,
    position: employee.cargo?.value,
    scholarship: employee.scholarship?.value,
    institution: employee.institution,
    degree: employee.degree,
    email: employee.email,
    contract: employee.type_contract?.value,
    salary_base: employee.salary_base,
    transport_subsidy: Number(employee.transport_subsidy),
    paymentMethods: employee.payment_method?.value,
    paymentFrecuencies: employee.frecuency_payment?.value,
    associatedBank: employee.associated_bank?.value,
    account_number: employee.account_number,
    file_certificate_bank_name: employee.certificate_banck_name_saved_name,
    vacation_acumulate: employee.vacation_acumulate,
    bonification_aditional: employee.bonification_aditional,
    date_start_contract: employee.date_start_contract,
    lunes: Number(employee.lunes),
    martes: Number(employee.martes),
    miercoles: Number(employee.miercoles),
    jueves: Number(employee.jueves),
    viernes: Number(employee.viernes),
    sabado: Number(employee.sabado),
    domingo: Number(employee.domingo),
    festivo: Number(employee.festivo),
    eps: employee.eps?.value,
    familyCompensationFund: employee.familyCompensation?.value,
    file_family_compensation_fund: employee.caja_compensacion_name_saved,
    saving: employee.cesantias?.value,
    file_savings: employee.cesantias_name_saved,
    retirement: employee.pension?.value,
    arl_name_saved: employee.arl_name_saved,
    vista_domiciliaria: Number(employee.vista_domiciliaria),
    visita_domiciliaria_name_saved: employee.visita_domiciliaria_name_saved,
    prueba_psicotecnica: Number(employee.prueba_psicotecnica),
    psicotecnica_name_saved: employee.psicotecnica_name_saved,
    manipulacion_alimentos: Number(employee.manipulacion_alimentos),
    manipulacion_alimentos_name_saved: employee.manipulacion_alimentos_name_saved,
    encuesta_dme: Number(employee.encuesta_dme),
    encuesta_dme_name_saved: employee.encuesta_dme_name_saved,
    trabajo_alturas: Number(employee.trabajo_alturas),
    trabajo_altura_name_saved: employee.trabajo_altura_name_saved,
    examen_medico: Number(employee.examen_medico),
    examen_medico_name_saved: employee.examen_medico_name_saved,
    contrato: Number(employee.contrato),
    certificado_estudios: Number(employee.certificado_estudios),
    certificado_estudios_name_saved: employee.certificado_estudios_name_saved,
    certificado_laboral: Number(employee.certificado_laboral),
    certificado_laboral_name_saved: employee.certificado_laboral_name_saved,
    verificacion_adres: Number(employee.verificacion_adres),
    verificacion_adres_name_saved: employee.verificacion_adres_name_saved,
    antecedentes: Number(employee.antecedentes),
    antecedentes_name_saved: employee.antecedentes_name_saved,
    entrevista: Number(employee.entrevista),
    entrevista_name_saved: employee.entrevista_name_saved,
    sociodemografica: Number(employee.sociodemografica),
    sociodemografica_name_saved: employee.sociodemografica_name_saved,
    compromiso_sst: Number(employee.compromiso_sst),
    compromiso_sst_name_saved: employee.compromiso_sst_name_saved,
    cv_name_saved_name: employee.cv_name_saved_name,
    file_signed_contract_name: employee.file_signed_contract_name,
    beneficiaries: employee.family || [],
    dotaciones: employee.items || [],
  };
};

export const toEditEmployeePayload = (employee: any) => {
  console.log('MAPPING EDIT PAYLOAD: ', employee.e_cedula_name_saved_name, employee);
  const avatarName =
    employee.e_foto_name_saved ||
    employee.employee_avatar ||
    employee.e_edit_foto_name_saved ||
    employee.e_img_upload_name_saved ||
    null;

  return {
    empleadoId: employee.empleadoId,
    employee_avatar: avatarName,
    typeDocument: employee.e_document_type?.value,
    document_number: employee.e_document_number?.toString(),
    expedition_place: employee.e_expedition_place,
    name: employee.e_name,
    last_name: employee.e_last_name,
    birthdate: employee.e_date_of_birth,
    gender: employee.e_gender?.value,
    civil_status: employee.e_civil_status?.value,
    landline: employee.e_landline,
    cell_phone: employee.e_cell_phone?.toString(),
    corporate_cell_phone: employee.e_corporate_cell_phone?.toString(),
    whatsapp: Number(employee.e_whatsapp),
    rh: employee.e_rh?.value,
    dominance: employee.e_dominance?.value,
    allergies: employee.e_allergies,
    cedula_name_saved_name: employee.e_cedula_name_saved_name,
    housing_type: employee.e_housing_type?.value,
    address: employee.e_address,
    neighborhood: employee.e_neighborhood,
    stratum: employee.e_stratum?.toString(),
    cost_center: employee.e_cost_center?.value,
    compani: employee.e_compani?.value,
    work_headquarters: employee.e_work_headquarters?.value,
    position: employee.e_cargo?.value,
    scholarship: employee.e_scholarship?.value,
    institution: employee.e_institution,
    degree: employee.e_degree,
    email: employee.e_email,
    contract: employee.e_type_contract ? employee.e_type_contract.value : null,
    salary_base: employee.e_salary_base,
    transport_subsidy: Number(employee.e_transport_subsidy),
    paymentMethods:
      employee.e_payment_method && employee.e_payment_method.value
        ? employee.e_payment_method.value
        : null,
    paymentFrecuencies:
      employee.e_frecuency_payment && employee.e_frecuency_payment.value
        ? employee.e_frecuency_payment.value
        : null,
    associatedBank:
      employee.e_associated_bank && employee.e_associated_bank.value
        ? employee.e_associated_bank.value
        : null,
    account_number: employee.e_account_number,
    file_certificate_bank_name: employee.e_certificate_banck_name_saved_name,
    vacation_acumulate: employee.e_vacation_acumulate,
    bonification_aditional: employee.e_bonification_aditional,
    date_start_contract: employee.e_date_start_contract,
    lunes: Number(employee.e_lunes),
    martes: Number(employee.e_martes),
    miercoles: Number(employee.e_miercoles),
    jueves: Number(employee.e_jueves),
    viernes: Number(employee.e_viernes),
    sabado: Number(employee.e_sabado),
    domingo: Number(employee.e_domingo),
    festivo: Number(employee.e_festivo),
    eps: employee.e_eps?.value,
    familyCompensationFund:
      employee.e_familyCompensation && employee.e_familyCompensation.value
        ? employee.e_familyCompensation.value
        : null,
    file_family_compensation_fund: employee.e_caja_compensacion_name_saved,
    saving: employee.e_cesantias && employee.e_cesantias.value ? employee.e_cesantias.value : null,
    file_savings: employee.e_cesantias_name_saved,
    retirement: employee.e_pension && employee.e_pension.value ? employee.e_pension.value : null,
    arl_name_saved: employee.e_arl_name_saved,
    vista_domiciliaria: Number(employee.e_vista_domiciliaria),
    visita_domiciliaria_name_saved: employee.e_visita_domiciliaria_name_saved,
    prueba_psicotecnica: Number(employee.e_prueba_psicotecnica),
    psicotecnica_name_saved: employee.e_psicotecnica_name_saved,
    manipulacion_alimentos: Number(employee.e_manipulacion_alimentos),
    manipulacion_alimentos_name_saved: employee.e_manipulacion_alimentos_name_saved,
    encuesta_dme: Number(employee.e_encuesta_dme),
    encuesta_dme_name_saved: employee.e_encuesta_dme_name_saved,
    trabajo_alturas: Number(employee.e_trabajo_alturas),
    trabajo_altura_name_saved: employee.e_trabajo_altura_name_saved,
    examen_medico: Number(employee.e_examen_medico),
    examen_medico_name_saved: employee.e_examen_medico_name_saved,
    contrato: Number(employee.e_contrato),
    certificado_estudios: Number(employee.e_certificado_estudios),
    certificado_estudios_name_saved: employee.e_certificado_estudios_name_saved,
    certificado_laboral: Number(employee.e_certificado_laboral),
    certificado_laboral_name_saved: employee.e_certificado_laboral_name_saved,
    verificacion_adres: Number(employee.e_verificacion_adres),
    verificacion_adres_name_saved: employee.e_verificacion_adres_name_saved,
    antecedentes: Number(employee.e_antecedentes),
    antecedentes_name_saved: employee.e_antecedentes_name_saved,
    entrevista: Number(employee.e_entrevista),
    entrevista_name_saved: employee.e_entrevista_name_saved,
    sociodemografica: Number(employee.e_sociodemografica),
    sociodemografica_name_saved: employee.e_sociodemografica_name_saved,
    compromiso_sst: Number(employee.e_compromiso_sst),
    compromiso_sst_name_saved: employee.e_compromiso_sst_name_saved,
    cv_name_saved_name: employee.e_cv_name_saved_name,
    file_signed_contract_name: employee.e_file_signed_contract_name,
    beneficiaries: employee.family || [],
    dotaciones: employee.items || [],
  };
};

export const toEditFormInitialValues = (employee: any) => {
  if (!employee) return formInitialValues;

  // Document Type
  let docType = null;
  if (employee.typeDocument) {
    if (typeof employee.typeDocument === 'object') {
      docType = {
        label:
          employee.typeDocument.type_document ||
          employee.typeDocument.label ||
          employee.typeDocument.name ||
          '',
        value: employee.typeDocument.id || employee.typeDocument.value || '',
      };
    } else {
      docType = { label: String(employee.typeDocument), value: employee.typeDocument };
    }
  }

  // Contract
  let contract = null;
  if (employee.type_contract) {
    contract =
      typeof employee.type_contract === 'object'
        ? employee.type_contract
        : { label: String(employee.type_contract), value: employee.type_contract };
  } else if (employee.contract) {
    contract =
      typeof employee.contract === 'object'
        ? {
            label: employee.contract.name || employee.contract.label || '',
            value: employee.contract.id || employee.contract.value || '',
          }
        : { label: String(employee.contract), value: employee.contract };
  }

  // Payment method
  let paymentMethod = null;
  if (employee.paymentMethods) {
    paymentMethod =
      typeof employee.paymentMethods === 'object'
        ? {
            label:
              employee.paymentMethods.payment_method ||
              employee.paymentMethods.label ||
              employee.paymentMethods.name ||
              '',
            value: employee.paymentMethods.id || employee.paymentMethods.value || '',
          }
        : { label: String(employee.paymentMethods), value: employee.paymentMethods };
  }

  // Payment frequency
  let paymentFrequency = null;
  if (employee.paymentFrecuencies) {
    paymentFrequency =
      typeof employee.paymentFrecuencies === 'object'
        ? {
            label:
              employee.paymentFrecuencies.payment_frequency ||
              employee.paymentFrecuencies.label ||
              employee.paymentFrecuencies.name ||
              '',
            value: employee.paymentFrecuencies.id || employee.paymentFrecuencies.value || '',
          }
        : { label: String(employee.paymentFrecuencies), value: employee.paymentFrecuencies };
  }

  // Associated bank
  let associatedBank = null;
  if (employee.associatedBank) {
    associatedBank =
      typeof employee.associatedBank === 'object'
        ? {
            label:
              employee.associatedBank.associated_bank ||
              employee.associatedBank.label ||
              employee.associatedBank.name ||
              '',
            value: employee.associatedBank.id || employee.associatedBank.value || '',
          }
        : { label: String(employee.associatedBank), value: employee.associatedBank };
  }

  // EPS
  let eps = null;
  if (employee.eps) {
    eps =
      typeof employee.eps === 'object'
        ? {
            label: employee.eps.name || employee.eps.label || '',
            value: employee.eps.id || employee.eps.value || '',
          }
        : { label: String(employee.eps), value: employee.eps };
  }

  // Family compensation
  let familyCompensation = null;
  const fc = employee.familyCompensationFund || employee.familyCompensation;
  if (fc) {
    familyCompensation =
      typeof fc === 'object'
        ? { label: fc.name || fc.label || '', value: fc.id || fc.value || '' }
        : { label: String(fc), value: fc };
  }

  // Cesantias
  let cesantias = null;
  const sv = employee.saving || employee.cesantias;
  if (sv) {
    cesantias =
      typeof sv === 'object'
        ? { label: sv.name || sv.label || '', value: sv.id || sv.value || '' }
        : { label: String(sv), value: sv };
  }

  // Pension
  let pension = null;
  const ret = employee.retirement || employee.pension;
  if (ret) {
    pension =
      typeof ret === 'object'
        ? { label: ret.name || ret.label || '', value: ret.id || ret.value || '' }
        : { label: String(ret), value: ret };
  }

  // Company
  let compani = null;
  if (employee.company) {
    compani =
      typeof employee.company === 'object'
        ? {
            label:
              employee.company.tradename || employee.company.name || employee.company.label || '',
            value: employee.company.id || employee.company.value || '',
          }
        : { label: String(employee.company), value: employee.company };
  }

  // Work headquarters (branch)
  let workHeadquarters = null;
  const br = employee.branch || employee.work_headquarters;
  if (br) {
    workHeadquarters =
      typeof br === 'object'
        ? { label: br.name || br.label || '', value: br.id || br.value || '' }
        : { label: String(br), value: br };
  }

  // Position (cargo)
  let cargo = null;
  const pos = employee.position || employee.cargo;
  if (pos) {
    cargo =
      typeof pos === 'object'
        ? { label: pos.name || pos.label || '', value: pos.id || pos.value || '' }
        : { label: String(pos), value: pos };
  }

  // Cost center
  let costCenter = null;
  if (employee.cost_center) {
    costCenter =
      typeof employee.cost_center === 'object'
        ? {
            label: employee.cost_center.name || employee.cost_center.label || '',
            value: employee.cost_center.id || employee.cost_center.value || '',
          }
        : { label: String(employee.cost_center), value: employee.cost_center };
  }

  // Beneficiaries
  const parentescoList = [
    { label: 'conyuge', value: 'Cónyuge' },
    { label: 'hijo', value: 'Hijo' },
    { label: 'hijastro', value: 'Hijastro' },
    { label: 'padre', value: 'Padre' },
    { label: 'madre', value: 'Madre' },
  ];
  const genderList = [
    { label: 'masculino', value: 'masculino' },
    { label: 'femenino', value: 'Femenino' },
    { label: 'otro', value: 'otro' },
  ];
  const escolaridadList = [
    { label: 'primaria', value: 'primaria' },
    { label: 'bachillerato', value: 'bachillerato' },
    { label: 'tecnico', value: 'tecnico' },
    { label: 'tecnologo', value: 'tecnologo' },
    { label: 'postgrado', value: 'postgrado' },
  ];

  const rawBeneficiaries = employee.beneficiaries || employee.family || [];
  const beneficiariesFormatted = Array.isArray(rawBeneficiaries)
    ? rawBeneficiaries.map((b: any) => {
        const parentescoObj =
          parentescoList.find((p) => p.value.toLowerCase() === b.parentesco?.toLowerCase()) ||
          (b.parentesco && typeof b.parentesco === 'object'
            ? b.parentesco
            : b.parentesco
              ? { label: b.parentesco, value: b.parentesco }
              : null);
        const generoObj =
          genderList.find((g) => g.value.toLowerCase() === b.genero?.toLowerCase()) ||
          (b.genero && typeof b.genero === 'object'
            ? b.genero
            : b.genero
              ? { label: b.genero, value: b.genero }
              : null);
        const escolaridadObj =
          escolaridadList.find((e) => e.value.toLowerCase() === b.escolaridad?.toLowerCase()) ||
          (b.escolaridad && typeof b.escolaridad === 'object'
            ? b.escolaridad
            : b.escolaridad
              ? { label: b.escolaridad, value: b.escolaridad }
              : null);

        return {
          ...b,
          parentesco: parentescoObj,
          genero: generoObj,
          escolaridad: escolaridadObj,
          fecha_nacimiento: b.birthdate || b.fecha_nacimiento || null,
          action: 'editar',
          editarId: b.id || b.editarId,
        };
      })
    : [];

  // Dotaciones
  const dotacionList = [
    { label: 'bata', value: 'bata' },
    { label: 'camisa', value: 'camisa' },
    { label: 'camiseta', value: 'camiseta' },
    { label: 'casco', value: 'casco' },
    { label: 'chaleco', value: 'chaleco' },
    { label: 'chaqueta impermeable', value: 'chaqueta_impermeable' },
    { label: 'corbata', value: 'corbata' },
    { label: 'delantal', value: 'delantal' },
    { label: 'falda short', value: 'falda_short' },
    { label: 'grillo', value: 'grillo' },
    { label: 'jean', value: 'jean' },
    { label: 'pantalon', value: 'pantalon' },
    { label: 'zapatos', value: 'zapatos' },
  ];

  const rawDotaciones = employee.dotaciones || employee.items || [];
  const dotacionesFormatted = Array.isArray(rawDotaciones)
    ? rawDotaciones.map((d: any) => {
        const dotacionItem = dotacionList.find((item) => item.value === d.item);
        return {
          ...d,
          nombre: dotacionItem || d.nombre || (d.item ? { label: d.item, value: d.item } : null),
          action: 'editar',
          dotacionId: d.id || d.dotacionId,
        };
      })
    : [];

  return {
    ...formInitialValues,
    empleadoId: employee.id || employee.userId || '',
    employee_avatar: employee.employee_avatar || '',
    e_foto_name_saved: employee.employee_avatar || '',
    e_document_type: docType,
    e_document_number: employee.document_number?.toString() || '',
    e_expedition_place: employee.expedition_place || '',
    e_name: employee.name || '',
    e_last_name: employee.last_name || '',
    e_date_of_birth: employee.birthdate || null,
    e_gender: employee.gender ? { label: employee.gender, value: employee.gender } : null,
    e_civil_status: employee.civil_status
      ? { label: employee.civil_status, value: employee.civil_status }
      : null,
    e_landline: employee.landline || '',
    e_cell_phone: employee.cell_phone?.toString() || '',
    e_corporate_cell_phone: employee.corporate_cell_phone?.toString() || '',
    e_whatsapp: Boolean(Number(employee.whatsapp)),
    e_rh: employee.rh ? { label: employee.rh, value: employee.rh } : null,
    e_dominance: employee.dominance
      ? { label: employee.dominance, value: employee.dominance }
      : null,
    e_allergies: employee.allergies || '',
    e_cedula_name_saved_name: employee.cedula_name_saved_name || '',
    e_housing_type: employee.housing_type
      ? { label: employee.housing_type, value: employee.housing_type }
      : null,
    e_neighborhood: employee.neighborhood || '',
    e_stratum: employee.stratum?.toString() || '',
    e_cost_center: costCenter,
    e_compani: compani,
    e_work_headquarters: workHeadquarters,
    e_cargo: cargo,
    e_cv_name_saved_name: employee.cv_name_saved_name || '',
    e_scholarship: employee.scholarship
      ? { label: employee.scholarship, value: employee.scholarship }
      : null,
    e_institution: employee.institution || '',
    e_degree: employee.degree || '',
    e_address: employee.address || '',
    e_email: employee.email || '',

    // Laboral
    e_type_contract: contract,
    e_salary_base: employee.salary_base ?? '',
    e_transport_subsidy: Boolean(Number(employee.transport_subsidy)),
    e_payment_method: paymentMethod,
    e_frecuency_payment: paymentFrequency,
    e_associated_bank: associatedBank,
    e_account_number: employee.account_number || '',
    e_certificate_banck_name_saved_name:
      employee.file_certificate_bank_name || employee.certificate_banck_name_saved_name || '',
    e_vacation_acumulate: employee.vacation_acumulate ?? '',
    e_bonification_aditional: employee.bonification_aditional ?? '',
    e_date_start_contract: employee.date_start_contract || null,
    e_lunes: Boolean(Number(employee.lunes)),
    e_martes: Boolean(Number(employee.martes)),
    e_miercoles: Boolean(Number(employee.miercoles)),
    e_jueves: Boolean(Number(employee.jueves)),
    e_viernes: Boolean(Number(employee.viernes)),
    e_sabado: Boolean(Number(employee.sabado)),
    e_domingo: Boolean(Number(employee.domingo)),
    e_festivo: Boolean(Number(employee.festivo)),
    e_dayrest: employee.dayrest || '',

    // Seguridad Social
    e_eps: eps,
    e_familyCompensation: familyCompensation,
    e_fileCajaCompensacion: employee.file_family_compensation_fund || null,
    e_caja_compensacion_name_saved:
      employee.file_family_compensation_fund || employee.caja_compensacion_name_saved || '',
    e_cesantias: cesantias,
    e_fileCesantias: employee.file_savings || null,
    e_cesantias_name_saved: employee.file_savings || employee.cesantias_name_saved || '',
    e_pension: pension,
    e_fileArl: employee.arl_name_saved || null,
    e_arl_name_saved: employee.arl_name_saved || '',

    // Beneficiarios y Dotaciones
    e_numOfBeneficiary: beneficiariesFormatted.length,
    family: beneficiariesFormatted,
    items: dotacionesFormatted,

    // Pruebas de ingreso
    e_vista_domiciliaria: Boolean(Number(employee.vista_domiciliaria)),
    e_visita_domiciliaria_name_saved: employee.visita_domiciliaria_name_saved || '',
    e_prueba_psicotecnica: Boolean(Number(employee.prueba_psicotecnica)),
    e_psicotecnica_name_saved: employee.psicotecnica_name_saved || '',
    e_manipulacion_alimentos: Boolean(Number(employee.manipulacion_alimentos)),
    e_manipulacion_alimentos_name_saved: employee.manipulacion_alimentos_name_saved || '',
    e_encuesta_dme: Boolean(Number(employee.encuesta_dme)),
    e_encuesta_dme_name_saved: employee.encuesta_dme_name_saved || '',
    e_trabajo_alturas: Boolean(Number(employee.trabajo_alturas)),
    e_trabajo_altura_name_saved: employee.trabajo_altura_name_saved || '',
    e_examen_medico: Boolean(Number(employee.examen_medico)),
    e_examen_medico_name_saved: employee.examen_medico_name_saved || '',
    e_contrato: Boolean(Number(employee.contrato)),
    e_certificado_estudios: Boolean(Number(employee.certificado_estudios)),
    e_certificado_estudios_name_saved: employee.certificado_estudios_name_saved || '',
    e_certificado_laboral: Boolean(Number(employee.certificado_laboral)),
    e_certificado_laboral_name_saved: employee.certificado_laboral_name_saved || '',
    e_verificacion_adres: Boolean(Number(employee.verificacion_adres)),
    e_verificacion_adres_name_saved: employee.verificacion_adres_name_saved || '',
    e_antecedentes: Boolean(Number(employee.antecedentes)),
    e_antecedentes_name_saved: employee.antecedentes_name_saved || '',
    e_entrevista: Boolean(Number(employee.entrevista)),
    e_entrevista_name_saved: employee.entrevista_name_saved || '',
    e_sociodemografica: Boolean(Number(employee.sociodemografica)),
    e_sociodemografica_name_saved: employee.sociodemografica_name_saved || '',
    e_compromiso_sst: Boolean(Number(employee.compromiso_sst)),
    e_compromiso_sst_name_saved: employee.compromiso_sst_name_saved || '',
    e_file_signed_contract_name: employee.file_signed_contract_name || '',

    // Controls
    with_photo: true,
    with_imagen: false,
    is_initialized_info_basica: true,
    is_initialized_info_laboral: true,
    is_initialized_seguridad_social: true,
    is_initialized_familia: true,
    is_initialized_dotacion: true,
    is_initialized_pruebas_ingreso: true,
  };
};
